import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface ExpiredVmsFailureProps {
  /** The backend's own sentence, verbatim. */
  message: string;
}

/**
 * The batch request itself failed: there is no per-row report, only the backend's sentence. Shown in
 * the dialog that started the request, so the reason stays on screen after a toast has gone.
 */
export function ExpiredVmsFailure({ message }: ExpiredVmsFailureProps) {
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>The request failed</AlertTitle>
      <AlertDescription className="space-y-2">
        <p>{message}</p>
        <p>
          The list has been read again. Check each row's status before trying
          again — a request that timed out may still have deleted some of them.
        </p>
      </AlertDescription>
    </Alert>
  );
}
